import { Component, ElementRef, EventEmitter, HostListener, OnInit, Output, ViewChild, ViewEncapsulation } from '@angular/core';
import { KYMW00Model } from '../../../commons/kymw00/kymw00.model';
import { PlessViewHelperSub } from '../../../commons/kymw00/pless-view-helper-sub';
import { FileDownloadService } from './../../../commons/kymw02/file-download-confirm/file-download.service';
import { KYMW1001Model } from './kymw1001.model';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { faListAlt, faBell, faUser, faArrowAltCircleLeft, faArrowAltCircleRight, faBuilding, faImages, faLightbulb } from '@fortawesome/free-regular-svg-icons';
import { faHome, faUserLock, faSlidersH, faUsers, faCaretUp, faCaretDown, faSignOutAlt, faExternalLinkAlt, faShoppingCart, faBookReader, faDesktop, faDatabase, faBriefcase, faCog, faWrench, faHandHoldingHeart } from '@fortawesome/free-solid-svg-icons';
import { Subscription } from 'rxjs';
import { filter } from 'rxjs/operators';
import { FunctionMenuService } from '../../../commons/kymw02/function-menu/function-menu.service';
import { PlessDialogService } from '../../../shared/pless-dialog-service';
import { KYMW1800Component } from '../../kymw18/kymw1800/kymw1800.component';
import { KYMW2200Component } from '../../kymw22/kymw2200/kymw2200.component';
import { KYMW2600Component } from '../../kymw26/kymw2600/kymw2600.component';
import { KYMW2800Component } from '../../kymw28/kymw2800/kymw2800.component';
import { KYMW2900Component } from '../../kymw29/kymw2900/kymw2900.component';
import { KYMW4000Component } from '../../kymw40/kymw4000/kymw4000.component';
import { KYMW4100Component } from '../../kymw41/kymw4100/kymw4100.component';
import { KYMW5900Component } from '../../kymw59/kymw5900/kymw5900.component';
import { KYMW6100Component } from '../../kymw61/kymw6100/kymw6100.component';
import { KYMW6600Component } from '../../kymw66/kymw6600/kymw6600.component';
import { KYMW9400Component } from '../../kymw94/kymw9400/kymw9400.component';
import { GetCommonSettingService } from './api-services/get-common-setting.service';
import { GetInitTopService } from './api-services/get-init-top.service';
import { KYMW0C00Component } from '../../../commons/kymw0c/kymw0c00/kymw0c00.component';
import { KYMW1704Component } from '../../kymw17/kymw1704/kymw1704.component';
import { KYMW9006Component } from '../../kymw90/kymw9006/kymw9006.component';
import { GetInitTopModel, PermissionModel, UserClassListModel } from './vo/get-init-top.model';
import { KYMW2000Component } from '../../kymw20/kymw2000/kymw2000.component';
import { LoginUserInfoService } from './login-services/loginUserInfo.service';

/**
 * トップ画面
 *
 * @export KYMW1001Component
 * @class KYMW1001Component
 * @implements {OnInit}
 */
@Component({
  selector: 'app-kymw1001',
  templateUrl: './kymw1001.component.html',
  styleUrls: ['./kymw1001.component.scss'],
  encapsulation: ViewEncapsulation.None
})

export class KYMW1001Component extends PlessViewHelperSub implements OnInit {
 @ViewChild('dashboard') dashBoardButton: ElementRef;

  public kymw1001Model: KYMW1001Model = new KYMW1001Model();

  /** @ignore ダッシュボード画面用アイコン. */
  faHome = faHome;

  /** @ignore ジョブ一覧アイコン. */
  faListAlt = faListAlt;

  /** @ignore パスワード変更アイコン. */
  faUserLock = faUserLock;

  /** @ignore 管理アイコン. */
  faSlidersH = faSlidersH;

  /** @ignore お知らせ管理アイコン. */
  faBell = faBell;

  /** @ignore ユーザー管理アイコン. */
  faUser = faUser;

  /** @ignore ユーザーグループ管理アイコン. */
  faUsers = faUsers;

  /** @ignore メニュー全体開閉ボタンアイコン. */
  faArrowAltCircleLeft = faArrowAltCircleLeft;

  /** @ignore メニュー全体開閉ボタンアイコン. */
  faArrowAltCircleRight = faArrowAltCircleRight;

  /** @ignore 管理メニュー開閉アイコン. */
  faCaretUp = faCaretUp;

  /** @ignore 管理メニュー開閉アイコン. */
  faCaretDown = faCaretDown;

  /** @ignore アイコン. */
  faSignOutAlt = faSignOutAlt;

  /** @ignore アイコン. */
  faBuilding = faBuilding;

  /** @ignore アイコン. */
  faPopup = faExternalLinkAlt;

  /** @ignore 親メニューアイコン. */
  iconGoodsInfoManagement = faShoppingCart;
  iconPlanGoods = faLightbulb;
  iconPublicationProduction = faBookReader;
  iconECProduction = faDesktop;
  iconImageManagement = faImages;
  iconProductPlanning = faHandHoldingHeart;
  iconMasterManagement = faDatabase;
  iconBusinessManagement = faBriefcase;
  iconSystemsManagement = faCog;
  iconDevelop = faWrench;

  /** タイトル. */
  mainTitle: string = null;

  /** メインコンテンツ部分の現在のコンポーネント. */
  activeComponent: any;

  /** サンプルメッセージ */
  messages: string[] = [];

  /** メインメニューが開いているか否か. */
  menuOpen = true;

  /** 管理メニューが開いているか否か. */
  managementMenuOpen = false;

  /** 親メニューオープン(true). */
  parentMenusOpen: { [key: string]: boolean } = {
    goodsInfoManagement: false,
    planGoods: false,
    publicationProduction: false,
    ecProduction: false,
    imageManagement: false,
    productPlanning: false,
    masterManagement: false,
    businessManagement: false,
    systemsManagement: false,
    develop: false
  };

  /** メニュー有効(false) or 無効(true). */
  menuDisabled: { [key: string]: boolean } = {
    // 商品情報管理
    KYMW6900: false,              // 商品提案検索
    KYMW1100: false,              // 商品マスタ
    KYMW4200: false,              // 商品マスタプルーフ
    KYMW4700: false,              // マルチコード一覧
    KYMW4300: false,              // 商品ＤＮＡ情報一覧
    // 商品企画
    KYMW1300: false,              // 商品企画マスタ
    KYMW1200: false,              // サイクル設定
    KYMW4500: false,              // 特集マスタ
    KYMW7000: false,              // 表紙・特集掲載商品選定（CX）
    KYMW7004: false,              // 特集商品提案状況確認（CXデザイン部用）
    KYMW7006: false,              // 表紙・特集商品選定依頼確認（グループ長用）
    KYMW7001: false,              // 表紙・特集掲載商品選定（バイヤー）
    KYMW7007: false,              // 表紙・特集商品選定依頼確認（担当バイヤー用）
    KYMW7003: false,              // 特集商品提案状況確認（取引先用）
    KYMW7500: false,              // 計画数確認
    KYMW2900: false,              // 農産フロント連携
    KYMW4000: false,              // 週次プロモーション商品計画表
    KYMW6700: false,              // 校正紙
    KYMW6600: false,              // 特別指示書
    KYMW7400: false,              // 忘れず注文商品一覧
    // KYMW2800: false,              // 週別部門別供給高ＧＰ予算進捗. 不使用のためコメントアウト
    // KYMW2000: false,              // 選定済商品数一覧. 不使用のためコメントアウト
    // 誌面制作
    KYMW1400: false,              // コマ割
    KYMW2100: false,              // 注文コード設定
    KYMW4100: false,              // 統一企画点検リスト
    KYMW2600: false,              // Ｗ掲載リスト出力
    KYMW2700: false,              // 基版コピー・フェーズ管理
    KYMW2300: false,              // 印刷会社用データ出力
    KYMW4400: false,              // ページ・台割編集
    KYMW2500: false,              // ページネーション設定
    KYMW2200: false,              // ＯＣＲデータメール送信
    // EC制作
    KYMW5300: false,              // ECカテゴリマスタ
    KYMW5400: false,              // ECカテゴリ関連マスタ
    KYMW6800: false,              // ECカテゴリ変換マスタ一覧
    KYMW6500: false,              // ECタイムセールマスタ一覧
    KYMW5900: false,              // EC企画商品一覧表
    KYMW5500: false,              // EC画像メンテ
    KYMW6000: false,              // EC使用画像一覧表
    KYMW6100: false,              // EC画像指示一覧表
    // 画像管理
    KYMW1700: false,              // 画像作成管理
    KYMW0C00: false,              // 画像作成指示
    KYMW1704: false,              // 画像個別登録
    KYMW1600: false,              // 画像確認
    KYMW1800: false,              // 画像チェックリスト出力
    // 運営商品企画
    KYMW7200: false,              // 運営商品一覧
    KYMW7300: false,              // 注文単位値引クーポン一覧
    // マスタ管理
    KYMW4800: false,              // クロス商品設定マスタ管理
    KYMW7100: false,              // 束ね企画回設定
    KYMW4600: false,              // タグ管理
    KYMW1500: false,              // マーク・アイコンマスタ
    KYMW0A00: false,              // 組合員の声管理
    KYMW2400: false,              // ページパターン設定
    KYMW9200: false,              // 企画回管理
    // 業務管理
    KYMW9400: false,              // 外部システム連携
    KYMW9300: false,              // お知らせ編集
    // システム管理
    KYMW9000: false,              // ユーザ一覧
    KYMW9003: false,              // 権限一覧
    KYMW9006: false,              // パスワード変更
    KYMW9009: false,              // ユーザ階層管理
    KYMW9100: false,              // ログ検索
  };

  /** ダイアログコンポーネント. */
  dialogComponents: { [key: string]: any } = {
    KYMW0C00: KYMW0C00Component,    // 画像作成指示
    KYMW1704: KYMW1704Component,    // 画像個別登録
    KYMW1800: KYMW1800Component,    // 画像チェックリスト出力
    KYMW2900: KYMW2900Component,    // 農産フロント連携
    KYMW6600: KYMW6600Component,    // 特別指示書
    KYMW2800: KYMW2800Component,    // 週別部門別供給高ＧＰ予算進捗
    KYMW2000: KYMW2000Component,    // 選定済商品数一覧
    KYMW4000: KYMW4000Component,    // 週次プロモーション商品計画表
    KYMW4100: KYMW4100Component,    // 統一企画点検リスト
    KYMW2600: KYMW2600Component,    // Ｗ掲載リスト出力
    KYMW2200: KYMW2200Component,    // ＯＣＲデータメール送信
    KYMW6100: KYMW6100Component,    // EC画像指示一覧表
    KYMW5900: KYMW5900Component,    // EC企画商品一覧表
    KYMW9400: KYMW9400Component,    // 外部システム連携
    KYMW9006: KYMW9006Component,    // パスワード変更
  };

  parentMenuDisplays: { [key: string]: boolean } = {
    goodsInfoManagement: false,
    imageManagement: false,
    planGoods: false,
    publicationProduction: false,
    ecProduction: false,
    masterManagement: false,
    businessManagement: false,
    systemsManagement: false,
    productPlanning: false,
    develop: 'localhost' === window.location.hostname
  };

  menuDisplays: { [key: string]: { [funcId: string]: boolean } } = {
    goodsInfoManagement: {
      KYMW6900: false,           // 商品提案検索
      KYMW1100: false,           // 商品マスタ
      KYMW4200: false,           // 商品マスタプルーフ
      KYMW4700: false,           // マルチコード一覧
      KYMW4300: false,           // 商品ＤＮＡ情報一覧
    },
    planGoods: {
      KYMW1300: false,           // 商品企画マスタ
      KYMW1200: false,           // サイクル設定
      KYMW4500: false,           // 特集マスタ
      KYMW7000: false,           // 表紙・特集掲載商品選定（CX）
      KYMW7004: false,           // 特集商品提案状況確認（CXデザイン部用）
      KYMW7006: false,           // 表紙・特集商品選定依頼確認（グループ長用）
      KYMW7001: false,           // 表紙・特集掲載商品選定（バイヤー）
      KYMW7007: false,           // 表紙・特集商品選定依頼確認（担当バイヤー用）
      KYMW7003: false,           // 特集商品提案状況確認（取引先用）
      KYMW7500: false,           // 計画数確認
      KYMW2900: false,           // 農産フロント連携
      KYMW4000: false,           // 週次プロモーション商品計画表
      KYMW6700: false,           // 校正紙
      KYMW6600: false,           // 特別指示書
      KYMW7400: false,           // 忘れず注文商品一覧
      // KYMW2800: false,           // 週別部門別供給高ＧＰ予算進捗. 不使用のためコメントアウト
      // KYMW2000: false,           // 選定済商品数一覧. 不使用のためコメントアウト
    },
    publicationProduction: {
      KYMW1400: false,           // コマ割
      KYMW2100: false,           // 注文コード設定
      KYMW4100: false,           // 統一企画点検リスト
      KYMW2600: false,           // Ｗ掲載リスト出力
      KYMW2700: false,           // 基版コピー・フェーズ管理
      KYMW2300: false,           // 印刷会社用データ出力
      KYMW4400: false,           // ページ・台割編集
      KYMW2500: false,           // ページネーション設定
      KYMW2200: false,           // ＯＣＲデータメール送信
    },
    ecProduction: {
      KYMW5300: false,           // ECカテゴリマスタ
      KYMW5400: false,           // ECカテゴリ関連マスタ
      KYMW6800: false,           // ECカテゴリ変換マスタ一覧
      KYMW6500: false,           // ECタイムセールマスタ一覧
      KYMW5900: false,           // EC企画商品一覧表
      KYMW5500: false,           // EC画像メンテ
      KYMW6000: false,           // EC使用画像一覧表
      KYMW6100: false,           // EC画像指示一覧表
    },
    imageManagement: {
      KYMW1700: false,           // 画像作成管理
      KYMW0C00: false,           // 画像作成指示
      KYMW1704: false,           // 画像個別登録
      KYMW1600: false,           // 画像確認
      KYMW1800: false,           // 画像チェックリスト出力
    },
    productPlanning: {
      KYMW7200: false,           // 運営商品一覧
      KYMW7300: false,           // 注文単位値引クーポン一覧
    },
    masterManagement: {
      KYMW4800: false,           // クロス商品設定マスタ管理
      KYMW7100: false,           // 束ね企画回設定
      KYMW4600: false,           // タグ管理
      KYMW1500: false,           // マーク・アイコンマスタ
      KYMW0A00: false,           // 組合員の声管理
      KYMW2400: false,           // ページパターン設定
      KYMW9200: false,           // 企画回管理
    },
    businessManagement: {
      KYMW9400: false,           // 外部システム連携
      KYMW9300: false,           // お知らせ編集
    },
    systemsManagement: {
      KYMW9000: false,           // ユーザ管理
      KYMW9003: false,           // 権限一覧
      KYMW9006: false,           // パスワード変更
      KYMW9009: false,           // ユーザ階層管理
      KYMW9100: false,           // ログ検索
    },
  };

  /**  */
  subscriptions: Subscription[] = [];

  resizeObserver!: ResizeObserver;

  @Output() childData = new EventEmitter<string>();

  constructor(
    private router: Router,
    public sharedModel: KYMW00Model,
    private activatedRoute: ActivatedRoute,
    private fmenuService: FunctionMenuService,
    private dialogService: PlessDialogService,
    public KYMW00Model: KYMW00Model,
    public getCommonSettingService: GetCommonSettingService,
    public getInitTopService: GetInitTopService,
    public fileDownloadService: FileDownloadService,
    private loginUserInfoService: LoginUserInfoService,
  ) {super(KYMW00Model);}

  ngOnInit() {
    this.getCommonSettingService.execute();

    this.getInitTopService.execute(this.kymw1001Model, (data: any) => {
      // APIレスポンスを保持
      this.updateUserDataSetList(data);
      this.updateFuncPermissionList(data);
      // メニューの表示制御
      this.menuDisplaysHandler();
      // ログアウトボタンの表示制御
      this.logoutDisplayHandler();
      // 共有用にログインユーザー情報を設定
      this.loginUserInfoService.setLoginUserInfo(this.KYMW00Model.kymw1001Model.loginUserInfo);
    });

    setInterval(() => {
      const uselessElements = document.querySelectorAll('[aria-hidden="true"]');
      uselessElements.forEach((element) => {
        element.setAttribute("aria-hidden", "false");
      });
    }, 5000);
  }

  ngAfterViewInit() {
    let timeout: any;
    let refId: number | null = null;
    const body = document.querySelector('.body') as HTMLElement;
    // ブラウザ拡大率の変更監視用
    this.resizeObserver = new ResizeObserver(() => {
      clearTimeout(timeout);
      if (refId !== null) {
        cancelAnimationFrame(refId);
      }
      timeout = setTimeout(() => {
        refId = requestAnimationFrame(() => {
          refId = null;
          body.style.maxHeight = '';

          // ngOnInitの縦スクロール表示制御と同様の処理
          /** app-kymw〇〇〇〇タグ */
          const contentsArea =  Array.from(body.children)
            .find((e)=> e.tagName.toLocaleLowerCase().startsWith('app-')) as HTMLElement;
          /** footer-buttonsクラス */
          const footer = document.querySelector('.footer-buttons') as HTMLElement;

          // フッターがある画面　かつ　縦スクロール表示がある画面 に遷移するとき
          if (footer && contentsArea.offsetHeight > (body.offsetHeight - footer.offsetHeight)) {
            body.style.maxHeight = body.offsetHeight - footer.offsetHeight + 'px';
          }
        })
      }, 50)
    });

    this.resizeObserver.observe(body);
  }

  ngOnDestroy() {
    this.subscriptions.forEach(subscription => subscription.unsubscribe());
    this.resizeObserver.disconnect();
  }

  /**
   * ダッシュボード画面ページへ移動
   */
  goToTopPage() {
    this.router.navigate(['/kymw/1002']);
  }

  logout() {
    this.KYMW00Model.kymw1001Model.loginUserInfo = null;
    this.router.navigate(['/login']);
  }

  /**
   * ダイアログオープン
   */
  public openDialogComponent(component: any) {
    const componentRef = this.dialogService.openModal(component, {
      modalDialogClass: 'modal-blur',
      backdrop: 'static',
      keyboard: false
    });
    const instance = componentRef.componentInstance;
    instance.closeFunction = () => {
      componentRef.close();
    };
  }

  /**
   * スペースキーで画面遷移
   */
  public routingTo(event: Event): void {
    const target = event.target as HTMLElement;
    const routerLink = target.getAttribute('routerLink');
    this.router.navigate([routerLink]);
  }

  /**
   * キーダウンイベントハンドラ
   */
  @HostListener('document:keydown', ['$event'])
  public onKeyDown(event: KeyboardEvent): void {
    // Ctrl + M でメインメニューのダッシュボード画面にフォーカスを当てる
    if (event.ctrlKey && event.key === 'm') {
      event.preventDefault();
      this.dashBoardButton.nativeElement.focus();
    }
  }

  /** 
   * フロントに必要な情報を格納する
   * 
   * @param {*} serverData サーバーから受信したデータ
   * @memberof KYMW1001Model
   */
  public updateUserDataSetList(serverData: any): void {
    if (serverData != null) {
      this.KYMW00Model.kymw1001Model.loginUserInfo.UserID = serverData.UserID;
      this.KYMW00Model.kymw1001Model.loginUserInfo.AuthoritySetID = serverData.AuthoritySetID;
      this.KYMW00Model.kymw1001Model.loginUserInfo.AdminDiv = serverData.AdminDiv
      this.KYMW00Model.kymw1001Model.loginUserInfo.PermissionList = serverData.PermissionList.map(data => 
        new PermissionModel(
          data.FuncID,
          data.FuncName,
          data.EnableMode
        )
      );
      this.KYMW00Model.kymw1001Model.loginUserInfo.PwdLimitDay = serverData.PwdLimitDay;
      this.KYMW00Model.kymw1001Model.loginUserInfo.Manual = serverData.Manual;
      this.KYMW00Model.kymw1001Model.loginUserInfo.BuyerCodeList = serverData.BuyerCodeList;
      this.KYMW00Model.kymw1001Model.loginUserInfo.AssociatedUserType = serverData.AssociatedUserType;
      this.KYMW00Model.kymw1001Model.loginUserInfo.SupplierCode = serverData.SupplierCode;
      this.KYMW00Model.kymw1001Model.loginUserInfo.UserClassList = serverData.UserClassList.map(data => 
        new UserClassListModel(
          data.ClassCode,
          data.UserClass
        )
      );
      this.KYMW00Model.kymw1001Model.loginUserInfo.PlanningSupportFlg = serverData.PlanningSupportFlg;
      this.KYMW00Model.kymw1001Model.loginUserInfo.SamlAuthFlg = serverData.SamlAuthFlg;
    }
  }

    /**
   * トップ画面の機能許可リスト更新
   *
   * @param {*} serverData サーバから取得された<Data>タグ
   * @memberof KYMW1001Model
   */
  public updateFuncPermissionList(serverData: GetInitTopModel): void {
    this.KYMW00Model.kymw1001Model.permissionList = serverData.PermissionList;
    this.KYMW00Model.kymw1001Model.funcPermissionMap = new Map<string, PermissionModel>();
    this.KYMW00Model.kymw1001Model.permissionList.forEach(fp => this.KYMW00Model.kymw1001Model.funcPermissionMap.set(fp.FuncID, fp));
  }

  /**
   * メニューの表示制御メソッド
   */
  public menuDisplaysHandler(): void {
    /** 機能IDから表示する画面を制御 */
    Object.keys(this.menuDisplays).map(parent => {
      let display = false;
      Object.keys(this.menuDisplays[parent]).map(funcId => {
        this.menuDisplays[parent][funcId] =
          ['1', '2'].includes(
            this.KYMW00Model.kymw1001Model.funcPermissionMap.get(funcId)?.EnableMode);
        display = (display || this.menuDisplays[parent][funcId]);
      });
      this.parentMenuDisplays[parent] = display;
    });
    // マニュアルダウンロードが表示されるためシステム管理はユーザ権限によらず常に表示
    this.parentMenuDisplays['systemsManagement'] = true;
  }

  /**
   * ログアウトボタンの表示制御メソッド
   */
  public logoutDisplayHandler(): void {
    this.childData.emit(this.KYMW00Model.kymw1001Model.loginUserInfo.SamlAuthFlg);
  }

  /**
   * ファイルダウンロードのイベント
   * @param event コールバック・イベントへの参照
   */
  public eventDownloadHandler(): void {
    this.fileDownloadService.execute(this.KYMW00Model.kymw1001Model.loginUserInfo.Manual, 'PEACE_取引先用操作マニュアル.pdf');
  }
}
